import { useGetPermission } from 'hooks/business/useNewPermisson';
import { DetailCard } from '../DetailCard';
import { BookUser, Hash, Mail, MapPin, Smartphone } from 'lucide-react';
import { CopyText } from '../CopyText';
import { useTranslate } from '@tolgee/react';

// phone && displaySensitive && platform !== 'mercado'
export const Customer = ({ order }: { order: Conversation.Trade.Vo }) => {
  const { t } = useTranslate();
  const { platform, buyerNick, phone, email = '', address = '', postCode = '' } = order;
  const displaySensitive = useGetPermission()('订单敏感信息');

  const baseInfoList = [
    {
      icon: <BookUser size={16} />,
      value: buyerNick,
      enable: !!phone && displaySensitive && platform !== 'mercado' && !!buyerNick,
    },
    {
      icon: <Smartphone size={16} />,
      value: phone,
      enable: !!phone && displaySensitive && platform !== 'mercado',
    },
    {
      icon: <Mail size={16} />,
      value: email,
      enable: !!email && displaySensitive,
    },
    { icon: <MapPin size={16} />, value: address, enable: !!address && displaySensitive },
    { icon: <Hash size={16} />, value: postCode, enable: !!postCode && platform === 'lazada' },
  ];

  return (
    <DetailCard title={t('aide.买家信息')}>
      <div className="flex flex-col gap-3">
        {baseInfoList.map(
          (item) =>
            item.enable && (
              <div className="flex items-start gap-1.5" key={item.value}>
                <span className="w-4 h-4 text-[var(--fett-text-secondary)] flex-shrink-0 mt-[3px]">
                  {item.icon}
                </span>
                <CopyText
                  text={item.value}
                  showIcon
                  ellipsis={false}
                  className="text-[var(--fett-text-primary)] break-all"
                />
              </div>
            ),
        )}
      </div>
    </DetailCard>
  );
};
